import React, { useState } from 'react'
import Reviews from '../../courses/CoursesSingle/Reviews';
import { FiCheck } from 'react-icons/fi';

const courseFeatures = [
   { icon: <FiCheck />, text: 'Become a UX designer.' },
   { icon: <FiCheck />, text: 'You will be able to add UX designer to your CV' },
   { icon: <FiCheck />, text: 'Become a UI designer.' },
   { icon: <FiCheck />, text: 'Build & test a full website design.' },
   { icon: <FiCheck />, text: 'Create your first UX brief & persona.' },
   { icon: <FiCheck />, text: 'How to use premade UI kits.' },
   { icon: <FiCheck />, text: 'Create quick wireframes.' },
   { icon: <FiCheck />, text: 'Downloadable exercise files' },
   { icon: <FiCheck />, text: 'Build a UX project from beginning to end.' },
   { icon: <FiCheck />, text: 'Learn to design websites & mobile phone apps.' },
   { icon: <FiCheck />, text: 'All the techniques used by UX professionals' },
   { icon: <FiCheck />, text: 'You will be able to talk correctly with other UX design.' }
];

function EventDetails() {
   const [showFullDescription, setShowFullDescription] = useState(false);

   const toggleDescription = () => {
      setShowFullDescription(!showFullDescription);
   };

   return (
      <div className=''>
         <h4 className="text-xl font-semibold text-dark-1 dark:text-white">About The Event</h4>

         <div className="relative mt-6">
            <div
               className={`text-gray-600 dark:text-gray-300 transition-all duration-500 ease-in-out
                  overflow-hidden ${showFullDescription ? 'max-h-[1000px]' : 'max-h-[180px]'}`}
            >
               <p>
                  Phasellus enim magna, varius et commodo ut, ultricies vitae velit. Ut nulla tellus, eleifend euismod pellentesque vel, sagittis vel justo. In libero urna, venenatis sit amet ornare non, suscipit nec risus. Sed consequat justo non mauris pretium at tempor justo sodales. Quisque tincidunt laoreet malesuada. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur.
               </p>
               <p className="mt-4">
                  This course is aimed at people interested in UI/UX Design. We'll start from the very beginning and work all the way through, step by step. If you already have some UI/UX Design experience but want to get up to speed using Adobe XD then this course is perfect for you too!
               </p>
               <p className="mt-4">
                  First, we will go over the differences between UX and UI Design. We will look at what our brief for this real-world project is, then we will learn about low-fidelity wireframes and how to make use of existing UI design kits.
               </p>
            </div>

            {/* Overlay de dégradé */}
            {!showFullDescription && (
               <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent
               dark:from-dark-1 dark:to-transparent pointer-events-none"></div>
            )}
         </div>

         <button
            onClick={toggleDescription}
            className="text-purple-1 font-medium underline mt-2 flex items-center
            dark:hover:text-purple-300 transition-colors"
         >
            {showFullDescription ? (
               <>
                  <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                  </svg>
                  Show Less
               </>
            ) : (
               <>
                  <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                  Show More
               </>
            )}
         </button>

         <div className="mt-12">
            <h4 className="text-xl font-semibold text-dark-1 dark:text-white mb-6">What you'll learn</h4>
            <div className="grid md:grid-cols-2 gap-6">
               {courseFeatures.slice(0, 6).map((feature, index) => (
                  <div key={index} className="flex items-center">
                     <div className="flex justify-center items-center w-5 h-5 rounded-full border
                     border-gray-300 dark:border-gray-600 mr-3 text-purple-1">
                        {feature.icon}
                     </div>
                     <span className="text-gray-700 dark:text-gray-300">{feature.text}</span>
                  </div>
               ))}
            </div>
            <div className="grid md:grid-cols-2 gap-6 mt-6">
               {courseFeatures.slice(6).map((feature, index) => (
                  <div key={index} className="flex items-center">
                     <div className="flex justify-center items-center w-5 h-5 rounded-full border border-gray-300
                     dark:border-gray-600 mr-3 text-purple-1">
                        {feature.icon}
                     </div>
                     <span className="text-gray-700 dark:text-gray-300">{feature.text}</span>
                  </div>
               ))}
            </div>
         </div>

         <div className="mt-12">
            <h4 className="text-xl font-semibold text-dark-1 dark:text-white">Event Content</h4>
            <ul className="mt-6 space-y-4 text-gray-600 dark:text-gray-300 list-disc pl-5">
               <li>You will need a copy of Adobe XD 2019 or above. A free trial can be downloaded from Adobe.</li>
               <li>No previous design experience is needed.</li>
               <li>No previous Adobe XD skills are needed.</li>
            </ul>
         </div>

         {/* Our Speakers */}
         <div className="mt-16">
            <h2 className="text-xl font-semibold text-dark-1 dark:text-white mb-8">Our Speakers</h2>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
               {[
                  { name: "Jerome Bell", role: "Marketing Coordinator", img: "/speakers/1.png" },
                  { name: "Bessie Cooper", role: "President of Sales", img: "/speakers/2.png" },
                  { name: "Kristin Watson", role: "Nursing Assistant", img: "/speakers/3.png" },
                  { name: "Ronald Richards", role: "Dog Trainer", img: "/speakers/4.png" }
               ].map((speaker, index) => (
                  <div key={index} className="text-center">
                     <img src={speaker.img} alt={speaker.name} className="w-full h-auto rounded-lg mx-auto" />
                     <h3 className="font-medium mt-4 text-dark-1 dark:text-white">{speaker.name}</h3>
                     <p className="text-gray-500 text-sm dark:text-gray-400">{speaker.role}</p>
                  </div>
               ))}
            </div>

            <Reviews />
         </div>
         
      </div>
   )
}

export default EventDetails